import { useSelector } from 'react-redux';

import { RootState } from '../types/graph';

export const useCurrentPage = () =>
  useSelector((state: RootState) => state.graph.currentPage);
